/**
 * Check if an array is valid
 *
 * @param {Array} array - array to check
 * @returns {boolean} true if array is valid (not-empty array), false otherwise
 */
export const isValidArray = (array = []) => {
  return Array.isArray(array) && array.length > 0;
};
